<div *ngIf="hasData; else noPhonesConnected">
  <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="end center" fxLayoutAlign.xs="start" fxLayoutGap="10px"
    fxLayoutGap.xs="0" class="search-form">
    <div fxFlex="30">
      <flex-search-input class="full-width" [formControl]="filterCtrl">
      </flex-search-input>
    </div>
  </div>

  <flex-table [dataSource]="dataSource" [tableConfig]="tableConfig" class="flat-table"
      [columnTemplates]="{'last_modified': tplTime, 'expires': tplTime}">

      <ng-template #tplTime let-item="row" let-col="col">
        {{item[col]|timeFormatDateTimeShort}}
      </ng-template>
  </flex-table>
</div>
<ng-template #noPhonesConnected>{{ 'sipphone.message.no_phone_connected' | translate }}</ng-template>
